import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import { forwardRef } from "react";
import { cn } from "../lib/cn";
import { LINK_CLASSES } from "../lib/link-classes";
/**
 * The one in-content hyperlink — docs/009-ui-design-guidelines.md, "Links".
 *
 * Renders an `<a>` for an external `href`, or, with `asChild`, styles its one
 * child (a router `Link`) without adding a wrapper element. It inherits the
 * surrounding type size and weight, so it sits inside a sentence, a table cell
 * or a card title unchanged.
 *
 * A raw `<a>` / `<Link>` in an app fails lint (`NO_RAW_LINK_ELEMENT`); this,
 * `BackLink`, and `Button asChild` are the only ways to put a link on a page.
 */
export const TextLink = forwardRef(function TextLink({ className, asChild = false, ...props }, ref) {
    const Component = asChild ? Slot : "a";
    return (_jsx(Component, { ref: ref, className: cn(LINK_CLASSES, "rounded-sm", className), ...props }));
});
TextLink.displayName = "TextLink";
//# sourceMappingURL=text-link.js.map